import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import Icon from '@ant-design/icons';
import { useDefaultLandingPageStore } from '@globalStore/defaultLandingPageStore';
import isDefaultLandingPage from '@utils/isDefaultLandingPage';
import HomeSvg from '@icons/home.svg';
import NewSvg from '@icons/new-icon.svg';
import { FeatureToggle } from '@components/common';
import globalStyles from '../index.less';
import AccessWrapper from '../AccessWrapper';

const { baseUrl } = window.conviva;

const FeatureTab = ({
  tabKey,
  isGA,
  feature,
  tabTitle,
  route,
  exact,
  isNewFeature = false,
  isNewBrowserTab = false,
}) => {
  const to = isNewBrowserTab ? `${route}` : `${baseUrl}${route}`;
  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    name: state.name,
    path: state.path,
  }));
  const isDefaultPage = isDefaultLandingPage(defaultLandingPage.url, to);
  const tabID = feature != null ? `default-icon-${feature}` : 'default-icon-trends';
  const isSharedTab = () => {
    const checkString = ['sharing', 'ba-drilldown', 'na-drilldown'];
    return checkString.some((string) => window.location.pathname.includes(string));
  };

  const getIcon = () => {
    const Icons = [] as React.ReactNode[];

    // More precise route matching to avoid false positives with sub-routes
    const isExactRouteMatch = exact
      ? window.location.pathname === route || window.location.pathname === `${baseUrl}${route}`
      : window.location.pathname.startsWith(route) ||
        window.location.pathname.startsWith(`${baseUrl}${route}`);

    if (isDefaultPage) {
      Icons.push(
        <Icon
          key={'home-icon-1'}
          className={classnames(globalStyles.homeIcon, {
            [globalStyles.active]: isExactRouteMatch && !isSharedTab(),
          })}
          component={HomeSvg}
          style={{ fontSize: '20px', verticalAlign: 'unset' }}
          id={tabID}
          data-test-id="home-icon"
        />,
      );
    }
    if (isNewFeature) {
      Icons.push(
        <Icon
          key={'home-icon-2'}
          className={classnames(globalStyles.homeIcon, {
            [globalStyles.active]: isExactRouteMatch,
          })}
          component={NewSvg}
          style={{ fontSize: '28px', paddingRight: '2px' }}
          data-test-id="new-icon"
        />,
      );
    }
    return Icons;
  };
  const getTab = () => (
    <AccessWrapper feature={feature}>
      <NavLink
        id={`tab-${tabKey}`}
        key={tabKey}
        to={to}
        className={({ isActive }) =>
          classnames(globalStyles.tab, { [globalStyles.active]: isActive })
        }
        style={isNewFeature ? { paddingLeft: 0 } : undefined}
        end={exact}
        target={isNewBrowserTab ? '_blank' : undefined}
      >
        {getIcon()}
        {tabTitle}
      </NavLink>
    </AccessWrapper>
  );

  if (isGA) {
    return getTab();
  }

  return <FeatureToggle feature={feature}>{getTab()}</FeatureToggle>;
};

export default FeatureTab;
